<template>
  <div class="content-center">
    <div class="contact">
      <div class="title">联系我们</div>
      <p class="detail">
        汇通数科智能科技有限公司<br>
        江苏省南京市玄武区钟灵街50号汇通达大厦C座<br>
        咨询时间：8:00AM-18:00PM
      </p>
    </div>
    <a class="tel" href="tel:400-639-9988">400-639-9988</a>
    <p class="copyright">

      <span>Copyright©2019-2024 汇通数科智能科技有限公司 版权所有</span></br>
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32010202011944"
         target="_blank" style="margin-right: 20px;color: #65B7FF;">苏公网安备32010202011944号</a></br>
      <a style="color: #65B7FF;" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">苏ICP备20013617号-18</a></br>
      <a
        target="_blank"
        style="padding: 0 4px;display: inline-block;color: #65B7FF;"
        href="https://static.qcos.cn/htdt/mobileapp/htsk/license/license.jpg"
      >营业执照</a>
      <span>|</span>
      <a style="color: #65B7FF;" target="_blank" href="https://static.qcos.cn/htdt/mobileapp/htsk/license/business-license.jpg">增值电信业务经营许可证 </a></br>
      <span>联系电话：400-639-9988</span>
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
  .content-center {
    background: #000;
    padding: 30px 0 21px;
    .contact {
      width: 350px;
      margin: 0 auto;
      .title {
        font-size: 18px;
        font-weight: 500;
        color: #F4F4F4;
        text-align: left;
      }
      .detail {
        margin-top: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #ABACAE;
        line-height: 2.3;
        text-align: left;
      }
    }

    .tel {
      display: inline-block;
      width: 343px;
      height: 50px;
      line-height: 50px;
      border-radius: 6px;
      border: 1px solid #ABACAE;
      margin: 25px auto;
      border: 1px solid #fff;
      border-radius: 6px;
      color: #fff;
      font-size: 20px;
      font-weight: 500;
    }
    .copyright {
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      color: #ABACAE;
      line-height: 1.7;
      margin-bottom: 21px;
    }
  }
</style>
